import styled from 'styled-components';

/**
 * @deprecated use a native datepicker hooked with react-hook-form instead.
 */
export const ReactDatePickerStyle = styled.div<{ hasError: boolean }>`
  position: relative;

  .react-datepicker {
    &__input-container {
      input {
        padding-top: 0;
        padding-bottom: 0;
        width: 100%;
        min-width: 0;
        outline: 2px solid transparent;
        outline-offset: 2px;
        position: relative;
        appearance: none;
        transition-property: var(--transition-property-common);
        transition-duration: var(--transition-duration-duration-200);
        font-size: var(--fontSizes-md);
        font-weight: 500;
        padding-inline-start: var(--space-space-12);
        padding-inline-end: var(--space-space-12);
        height: 40px;
        border-radius: var(--radii-radius-6);
        border: 1px solid;
        border-color: ${(props) =>
          props.hasError ? 'var(--colors-error-signal)' : 'inherit'};
        background: inherit;

        &::placeholder {
          color: var(--colors-grey-0);
        }

        // Override https://github.com/shinetools/web-app/blob/34f673f098f8fd83a69093845f5fe094f4205716/src/components/Input/styles.ts#L14
        &:not(:focus)::placeholder {
          color: var(--colors-grey-0);
        }

        &:hover {
          border-color: var(--colors-grey-1);
          background-color: var(--colors-blue-4);
        }

        &:focus {
          z-index: 1;
          outline-offset: 2px;
          border-color: var(--colors-blue--1);
          box-shadow: 0 0 0 1px var(--colors-blue--1);
        }
      }
    }
  }
`;
